import { StyleSheet } from "aphrodite";

export default StyleSheet.create({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        flexDirection: "column",
        width: "100%"
    },
    title: {
        margin: "14px 0px 25px 0px"
    },
    titleRow: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 24,
        marginTop: 24,
        marginBottom: 10,
    },
    titleIcon: {
        height: 40,
        width: "auto",
    },
    alignStart: {
        alignSelf: "flex-start"
    },
    subTitle: {
        fontSize: "24px",
    },
    description: {
        padding: "30px 0px",
        textAlign: "center",
    },
    referenceNumberTitle: {
        marginTop: "30px"
    },
    mobileButton: {
        width: "100%",
        height: "60px",
        maxWidth: "400px",
        marginBottom: 10
    },
    gap: {
        marginBottom: 20
    },
    captchaContainer: {
        paddingBottom: 15,
    },
    descriptionContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: 10,
        textAlign: "center",
    },
});
